import { ContentMetadata, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import { generatePath, Link } from 'react-router-dom';
import { SpaceBetween } from '@amzn/awsui-components-core';
import { convertEntities } from '@amzn/awscat-editor';
import '../../resources/styles/scss/components/workflow-viewer/workflow-viewer.scss';
import AppContextProps from '../../contexts/AppContextProps';
import { withAppContext } from '../../contexts/AppContext';
import RouterPaths from '../../common/RouterPaths';
import { getContentPath } from '../../common/ContentPaths';
import { LEGACY_REDIRECT_STATES } from '../v2-common/LegacyWorkflowStates';

interface Props extends AppContextProps {
  contentId: string;
  metadata: ContentMetadata;
  draftState: WorkflowState;
  navigateBackTo?: string;
}

const PublisherContentViewerLink = ({
  contentId,
  metadata,
  draftState,
  navigateBackTo,
  appContext,
}: Props) => {
  // Contents submitted using the legacy UI (peer review) must be approved using old UI.
  // Contents submitted using the new UI (quality check, etc.) must be approved using the new UI.
  const pathname = LEGACY_REDIRECT_STATES.has(draftState)
    ? generatePath(RouterPaths.PUBLISHER_CONTENT_VIEWER, { contentId })
    : getContentPath({ contentId, mode: 'draft', role: 'admin' });

  return (
    <SpaceBetween size="xs" direction="horizontal">
      <Link to={{ pathname, state: { navigateBackTo } }} className="no-text-decoration">
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    </SpaceBetween>
  );
};

export default withAppContext(PublisherContentViewerLink);
